import { useContext } from 'react';
import { AuthContext, AuthContextType } from '@providers/AuthProvider';

/**
 * Hook to use centralized authentication
 * This is the ONLY hook components should use for authentication
 * Replaces: useAuthStore, useLogto, useLogtoAuthBridge (deprecated and deleted)
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
